import React, { useState, useEffect } from 'react';
import { SlideoutMenu } from './utilities/SlideoutMenu.tsx';
import { Offcanvas } from 'react-bootstrap';
import {
    BeardedDragonCare,
    LeopardGeckoCare,
    RedTailBoaCare,
    ReticulatedPythonCare,
    BallPythonCare,
    CornSnakeCare
} from './caresheets/Caresheets.tsx';
import { ToolMenuButton } from './collection/Collection.tsx';
import { useRepToolContext } from '../RepToolContext.tsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faList, faHome, faTimes } from '@fortawesome/free-solid-svg-icons';

const CareSheetContent = ({ selectedReptile, setChapters, backToMenu }) => {
    switch (selectedReptile) {
        case 'BD':
            return <BeardedDragonCare setChapters={setChapters} backToMenu={backToMenu} />
        case 'LG':
            return <LeopardGeckoCare setChapters={setChapters} backToMenu={backToMenu} />
        case 'CS':
            return <CornSnakeCare setChapters={setChapters} backToMenu={backToMenu} />
        case 'RT':
            return <RedTailBoaCare setChapters={setChapters} backToMenu={backToMenu} />
        case 'RP':
            return <ReticulatedPythonCare setChapters={setChapters} backToMenu={backToMenu} />
        case 'BP':
            return <BallPythonCare setChapters={setChapters} backToMenu={backToMenu} />
    }
}

const MenuContent = ({ chapters }) => {
    return (
        <div className='d-flex flex-column mt-5'>
            {chapters.map(chapter => (
                <ToolMenuButton clickFunction={() => { document.getElementById(chapter)?.scrollIntoView({ behavior: 'smooth' }); }} >
                    {chapter}
                </ToolMenuButton>
            ))}
        </div>
    )
}
const FloatButtons = ({ backToMenu, toggleOpenChapters }) => {
    return (
        <div className="d-flex flex-row ml-auto justify-content-end mb-2">
            <span className="mr-4" onClick={backToMenu} >
                <FontAwesomeIcon size='xl' icon={faHome} />
            </span>
            <span onClick={toggleOpenChapters} className="mr-2">
                <FontAwesomeIcon size='xl' icon={faList} />
            </span>
        </div>
    )
}

export const CareSheet = ({ backToMenu, selectedReptile }) => {
    const [openChapters, setOpenChapters] = useState(false);
    const [chapters, setChapters] = useState([]);
    const { appendControls } = useRepToolContext();

    useEffect(() => {
        appendControls(<FloatButtons backToMenu={backToMenu} toggleOpenChapters={() => setOpenChapters(!openChapters)} />, "Care Sheet")
    }, [openChapters])

    return (
        <div className='fadeIn animated'>
            <Offcanvas className='bg-black border-right px-4 text-light' show={openChapters} onHide={() => setOpenChapters(false)}>
                <Offcanvas.Header className='text-light d-flex justify-content-end' >
                    <div onClick={() => { setOpenChapters(false); }} className='close-canvas'>
                        <FontAwesomeIcon icon={faTimes} size='2x' />
                    </div>
                </Offcanvas.Header>
                <MenuContent chapters={chapters} />

            </Offcanvas>
            <div className='bg-black px-3'>
                <CareSheetContent selectedReptile={selectedReptile} setChapters={setChapters} backToMenu={backToMenu} />
            </div>

        </div>
    )
}